/** Pixen Intrigue — English world-UI overrides. Courtly-fae voice. */
export const worldPixEn = {
  'world.seo.description':
    'Explore the interactive maps of Pixen Intrigue — its courts, salons, and the scenes of legend, in 2D cartograph and a rotatable 3D globe.',
  'world.intro':
    'Chart the courts of the fae. The atlas is built for nested vision — zoom from the whole Court down to a single salon. Only the topmost tier is interactive for now; deeper tiers will open as the courts are mapped.',

  'world.gazetteer.sampleNotice': "Showing sample places — the Court's true survey is not yet recorded.",
  'world.gazetteer.error': 'The Court archive could not be reached.',

  'world.loading.atlas': 'Unrolling the atlas…',
  'world.loading.globe': 'Spinning the Court…',

  'world.map2d.noOverworld': 'Overworld map not yet recorded — showing the void',

  'world.globe.uncharted': 'Unclaimed Court',
  'world.globe.unchartedBlurb': 'No campaign has claimed this corner of the Court. Stake the first claim.',
  'world.globe.capitalLabel': 'The Hollow Court',
} as const
